import { render, staticRenderFns } from "./DossierDiff.vue?vue&type=template&id=9d1a75aa&scoped=true&"
import script from "./DossierDiff.vue?vue&type=script&setup=true&lang=js&"
export * from "./DossierDiff.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DossierDiff.vue?vue&type=style&index=0&id=9d1a75aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1a75aa",
  null
  
)

export default component.exports